import { createContext, useState } from 'react';
import api from 'services/api';

export const IndicadorQualidadeRespContext = createContext();

export const IndicadorQualidadeRespProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [indicadorQualidadeResp, setIndicadorQualidadeResp] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getIndicadorQualidadeResp = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: indicadorQualidadeResp?.filter,
        page: indicadorQualidadeResp?.page,
        size: indicadorQualidadeResp?.size,
        order: indicadorQualidadeResp?.order,
        ...payload,
      });
      setIndicadorQualidadeResp((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <IndicadorQualidadeRespContext.Provider
      value={{
        getLoading,
        indicadorQualidadeResp,
        getIndicadorQualidadeResp,
      }}
    >
      {children}
    </IndicadorQualidadeRespContext.Provider>
  );
};
